import { Button, Text, useDisclosure } from "@chakra-ui/react";
import { Parts, UI } from "components";

export default function DownlineRegister(props){

    const dialog = useDisclosure()

    return(
    <>
    <Parts.Dialog.Indication {...dialog} />
    <UI.Box {...props}>
        <Text children="Cadastrar downline" />
        <Text fontSize="xs" color="GrayText" children="Cadastre pessoas e aumente a sua rede" />
        <Button size="xs" children="Cadastrar downline" mt={4} colorPalette="orange" onClick={dialog.onOpen} />
    </UI.Box>
    </>
    )
}